import { postData } from './PostData';
import { global } from "./Global";

export const miniCart = () => {
	const miniCart = document.getElementById('mini-cart');
	const openMiniCart = document.querySelectorAll('#open-mini-cart');
	const cart = document.getElementsByClassName('cart-wrapper');
	const checkout = document.getElementsByClassName('checkout-wrapper');

	/**
	 * Load cart content
	 */
	const loadMiniCartQty = () => {
		const form = new FormData();

		form.append('action', 'cl_load_cart_qty');
		form.append('_ajax_nonce', my_ajax_object.nonce);
		form.append('blocksToUpdate', global.getBlocksToUpdate());

		const params = new URLSearchParams(form);

		postData(my_ajax_object.ajax_url, params)
			.then(response => {
				document.getElementById('loader').style.display = 'none';

				if (!response || response.error) {
					return;
				}

				global.updateBlocks(response);
			});
	}
	loadMiniCartQty();

	/**
	 * Load cart content
	 */
	const loadMiniCart = () => {
		document.getElementById('loader').style.display = 'flex';

		const form = new FormData();

		form.append('action', 'cl_load_cart');
		form.append('_ajax_nonce', my_ajax_object.nonce);
		form.append('blocksToUpdate', global.getBlocksToUpdate());

		const params = new URLSearchParams(form);

		postData(my_ajax_object.ajax_url, params)
			.then(response => {
				document.getElementById('loader').style.display = 'none';

				if (!response || response.error) {
					return;
				}

				global.updateBlocks(response);

				miniCart.style.display = 'flex';
				document.body.style.overflow = 'hidden';
			});
	}

	const openMiniCartHandler = (e) => {
		e.preventDefault();

		if (checkout.length > 0 || cart.length > 0) {
			const cartLink = e.target.closest('a');

			if (!cartLink) {
				return;
			}

			location.href = cartLink.getAttribute('href');

			return
		}

		loadMiniCart();
	}

	if (openMiniCart) {
		openMiniCart.forEach(function (miniCartHandler) {
			miniCartHandler.addEventListener('click', openMiniCartHandler);
		});
	}


	window.miniCart = () => {
		return {
			subTotal: '',
			total: '',
			freeShippingFrom: 0,
			tillFreeShipping: 0,
			tillFreeShippingStyle: '',
			discountForm: false,
			couponCode: '',
			discount: '',
			showDiscount: false,

			init(subTotal, total, freeShippingFrom, discount) {
				this.subTotal = `${parseFloat(subTotal).toFixed(2)} €`;
				this.total = `${parseFloat(total).toFixed(2)} €`;
				this.freeShippingFrom = parseFloat(freeShippingFrom).toFixed(2);

				if (typeof discount === 'string' && discount) {
					this.discount = discount;
					this.showDiscount = true;
				} else if (discount) {
					this.discount = `${parseFloat(discount).toFixed(2)} €`
					this.showDiscount = true;
				}

				this.tillFreeShipping = (freeShippingFrom - total).toFixed(2);
				this.tillFreeShippingStyle = `width: ${((total * 100) / freeShippingFrom).toFixed(2)}%`;

			},
			closeMiniCart() {
				miniCart.style.display = 'none';
				document.body.style.overflow = '';
			},
		}
	}
}
